module.exports = __webpack_public_path__ + "static/media/kwetb.ab3c7d79.png";